var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "form", attrs: { model: _vm.user, rules: _vm.rules } },
    [
      _c(
        "el-form-item",
        { attrs: { label: "姓名", prop: "name" } },
        [
          _c("el-input", {
            model: {
              value: _vm.user.name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.user,
                  "name",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "user.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "手机号", prop: "mobile" } },
        [
          _c("el-input", {
            model: {
              value: _vm.user.mobile,
              callback: function ($$v) {
                _vm.$set(
                  _vm.user,
                  "mobile",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "user.mobile",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "电子邮箱", prop: "email" } },
        [
          _c("el-input", {
            model: {
              value: _vm.user.email,
              callback: function ($$v) {
                _vm.$set(
                  _vm.user,
                  "email",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "user.email",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }